import { render, staticRenderFns } from "./SwabSampleAnalysisChartHeader.vue?vue&type=template&id=030c3a37&scoped=true&"
import script from "./SwabSampleAnalysisChartHeader.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysisChartHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SwabSampleAnalysisChartHeader.vue?vue&type=style&index=0&id=030c3a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c3a37",
  null
  
)

export default component.exports